const PINCODE_REGEX = /^[1-9][0-9]{5}$/;

function parseList(raw) {
  return (raw || '')
    .split(/[,\n]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

class PincodeChecker extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.onInput = this.onInput.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('[data-pincode-form]');
    this.input = this.querySelector('[data-pincode-input]');
    this.message = this.querySelector('[data-pincode-message]');

    if (!this.form || !this.input || !this.message) return;

    const rawPrefixes = parseList(this.dataset.allowedPrefixes);
    const rawExact = parseList(this.dataset.allowedPincodes);

    this.allowedPrefixes = rawPrefixes.filter((value) => /^[1-9][0-9]{2,5}$/.test(value));
    this.allowedExactPincodes = new Set(rawExact.filter((value) => PINCODE_REGEX.test(value)));

    // Hard safety fallback for Ahmedabad + Gandhinagar
    if (this.allowedPrefixes.length === 0 && this.allowedExactPincodes.size === 0) {
      this.allowedPrefixes = ['380', '382'];
    }

    this.messages = {
      empty: this.dataset.msgEmpty || 'Please enter pincode.',
      invalid: this.dataset.msgInvalid || 'Please enter a valid 6-digit pincode.',
      success: this.dataset.msgSuccess || 'Delivery is available in your area.',
      unavailable: this.dataset.msgUnavailable || 'Delivery is not available in your area.',
    };

    this.form.addEventListener('submit', this.onSubmit);
    this.input.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    if (this.input) this.input.removeEventListener('input', this.onInput);
  }

  onInput() {
    const digits = this.input.value.replace(/\D/g, '').slice(0, 6);
    if (digits !== this.input.value) this.input.value = digits;

    if (this.message.textContent) {
      this.clearMessage();
      this.input.removeAttribute('aria-invalid');
    }
  }

  onSubmit(event) {
    event.preventDefault();

    const pincode = this.input.value.trim();

    if (!pincode) {
      this.setMessage('error', this.messages.empty);
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
      return;
    }

    if (!PINCODE_REGEX.test(pincode)) {
      this.setMessage('error', this.messages.invalid);
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
      return;
    }

    if (this.isServiceable(pincode)) {
      this.setMessage('success', this.messages.success);
      this.input.removeAttribute('aria-invalid');
      return;
    }

    this.setMessage('error', this.messages.unavailable);
    this.input.removeAttribute('aria-invalid');
  }

  isServiceable(pincode) {
    if (this.allowedExactPincodes.has(pincode)) return true;
    return this.allowedPrefixes.some((prefix) => pincode.startsWith(prefix));
  }

  setMessage(state, text) {
    this.message.textContent = text;
    this.message.setAttribute('data-state', state);
  }

  clearMessage() {
    this.message.textContent = '';
    this.message.removeAttribute('data-state');
  }
}

if (!customElements.get('pincode-checker')) {
  customElements.define('pincode-checker', PincodeChecker);
}
